'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.mapStateToProps = mapStateToProps;

var _objAsArray = require('shared/utils/objAsArray');

var _objAsArray2 = _interopRequireDefault(_objAsArray);

var _constants = require('shared/utils/match/constants');

var _constants2 = _interopRequireDefault(_constants);

var _getMatchForJob = require('shared/utils/match/getMatchForJob');

var _getMatchForJob2 = _interopRequireDefault(_getMatchForJob);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var parseMatchTooltip = function parseMatchTooltip(route, _ref) {
  var _ref$data = _ref.data,
      jobs = _ref$data.jobs,
      interests = _ref$data.interests,
      skills = _ref$data.skills,
      educationLevels = _ref$data.educationLevels,
      user = _ref.user;

  var slug = route.split('/').pop();
  var job = jobs[slug];
  var matches = (0, _getMatchForJob2.default)(job, user, {
    skills: (0, _objAsArray2.default)(skills),
    interests: (0, _objAsArray2.default)(interests),
    educationLevels: (0, _objAsArray2.default)(educationLevels)
  }, _constants2.default);

  return {
    type: 'match',
    match: matches.match
  };
};

function mapStateToProps(state, _ref2) {
  var tooltips = _ref2.tooltips,
      route = _ref2.route;

  return {
    tooltips: tooltips.map(function (tooltip) {
      if (tooltip.type === 'match') {
        return parseMatchTooltip(route, state);
      }

      return (0, _extends3.default)({}, tooltip);
    })
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/Tooltips/selectors.js
// module id = 1270
// module chunks = 0